import React from "react";
const CustomBox = ({ show, message, onCancel, onConfirm }) => {
  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000, // Make sure the modal is on top
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "8px",
          width: "300px",
          textAlign: "center",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h3>Confirm Removal</h3>
        <p>{message}</p>
        <div>
          <button
            onClick={onCancel}
            style={{
              padding: "10px 20px",
              marginRight: "10px",
              backgroundColor: "#ccc",
              border: "none",
              borderRadius: "4px",
              marginTop: "15px",
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: "10px 20px",
              backgroundColor: "red",
              color: "white",
              border: "none",
              borderRadius: "4px",
            }}
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomBox;
